import { z } from "zod";

export const phoneNumberSchema = z.object({
  phoneNumber: z.string().min(5, { message: "این فیلد الزامی است" }),
});
export const usernamePasswordSchema = z.object({
  username: z.string().min(5, { message: "این فیلد الزامی است" }),
  password: z.string().min(5, { message: "این فیلد الزامی است" }),
});
export const otpSchema = z.object({
  id: z.string(),
  phoneNumber: z.string(),
  code: z.string().min(5, { message: "این فیلد الزامی است" }),
});

export type otpFormFields = z.infer<typeof otpSchema>;

export type phoneNumberFields = z.infer<typeof phoneNumberSchema>;

export type usernamePasswordFields = z.infer<typeof usernamePasswordSchema>;
